import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    downloadCSV,
    CardActions,
    ExportButton,
    DateInput,
    Filter,
    TextInput
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import jsonExport from 'jsonexport/dist';
import { DetailView } from './merchant_orders';

const OrderStatus = ({ record }) => {
    switch (record.status) {
        case 'D':
            return <Chip label="Delivered" style={{ margin: '2px', backgroundColor: '#4caf50', color: 'white' }} />;
        case 'C':
            return <Chip label="Cancelled" style={{ margin: '2px', backgroundColor: '#f44336', color: 'white' }} />;
        case 'A':
            return <Chip label="Accepted" style={{ margin: '2px', backgroundColor: '#ff9800', color: 'white' }} />;
        case 'O':
            return <Chip label="Out For Delivery" style={{ margin: '2px', backgroundColor: 'blue', color: 'white' }} />;
        default:
            return <Chip label="Pending" style={{ margin: '2px', backgroundColor: '#31708f', color: 'white' }} />;
    }
}

const DeliveryAddress = ({ record }) =>
    record.address.landmark ? `${record.address.address}, ${record.address.landmark}, ${record.address.city}` : `${record.address.address}, ${record.address.city}`;

const OrderFilter = (props) => (
    <Filter {...props}>
        <TextInput source="id" label="Order ID" />
        <TextInput source="merchantName" label="Restaurant" />
        <TextInput source="name" label="Customer Name" />
        <TextInput source="mobileNo" label="Mobile No" />
        <DateInput source="_fromDate" label="From Date" />
        <DateInput source="_toDate" label="To Date" />
    </Filter>
);

const getOrderStatus = status => {
    switch (status) {
        case 'D': return 'DELIVERED';
        case 'C': return 'CANCELLED';
        case 'A': return 'ACCEPTED';
        case 'O': return 'OUT FOR DELIVERY';
        case 'N': return 'PENDING';
        default: return 'UNKNOWN';
    }
};

const getDate = date => {
    let dd = date.getDate();
    let mm = date.getMonth() + 1;
    const yyyy = date.getFullYear();
    if (dd < 10) {
        dd = `0${dd}`;
    }

    if (mm < 10) {
        mm = `0${mm}`;
    }
    return `${yyyy}-${mm}-${dd}`;
};

const exporter = orders => {
    const data = orders.map(order => {
        order.ORDER_ID = order.id;
        order.RESTAURANT_NAME = order.merchantName;
        order.CUSTOMER_NAME = order.name;
        order.CUSTOMER_MOBILE_NO = order.mobileNo;
        order.ADDRESS = `${order.address.address}, ${order.address.city}`;
        order.TOTAL_AMOUNT = order.totalAmount;
        order.TOTAL_ACTUAL_AMOUNT = order.totalActualAmount;
        order.TAX = order.tax;
        order.DELIVERY_CHARGES = order.deliveryCharges;
        order.DISCOUNT_AMOUNT = order.discountAmount ? order.discountAmount : 0;
        order.COUPON_CODE = order.couponCode ? order.couponCode : '';
        order.TOTAL_PAYABLE = order.totalPayable;
        order.ORDER_STATUS = getOrderStatus(order.status);
        order.ORDER_DATE = getDate(new Date(order.creationTime));
        order.ORDER_TIME = new Date(order.creationTime);
        order.LAST_STATUS_UPDATED = order.lastStatusUpdateTime ? new Date(order.lastStatusUpdateTime) : '';
        return order;
    });

    jsonExport(data, {
        headers: ['ORDER_ID', 'RESTAURANT_NAME', 'CUSTOMER_NAME', 'CUSTOMER_MOBILE_NO', 'ADDRESS',
            'TOTAL_AMOUNT', 'TOTAL_ACTUAL_AMOUNT', 'TAX', 'DELIVERY_CHARGES', 'DISCOUNT_AMOUNT', 'COUPON_CODE', 'TOTAL_PAYABLE',
            'ORDER_STATUS', 'ORDER_DATE', 'ORDER_TIME', 'LAST_STATUS_UPDATED']
    }, (err, csv) => {
        downloadCSV(csv, `orders_${new Date().getTime()}`);
    });
};

const OrderActions = ({
    currentSort,
    displayedFilters,
    exporter,
    filters,
    filterValues,
    resource,
    showFilter
}) => (
    <CardActions>
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        <ExportButton
            resource={resource}
            sort={currentSort}
            filter={filterValues}
            exporter={exporter}
            maxResults={10000}
        />
    </CardActions>
);

export const CityOrderList = (props) => (
    <List {...props} title="Orders" bulkActionButtons={false}
        exporter={exporter} actions={<OrderActions />} filters={<OrderFilter />}
        sort={{ field: "creationTime", order: "DESC" }}>
        <Datagrid expand={<DetailView />}>
            <TextField source="id" label="Order ID" />
            <TextField source="merchantName" label="Restaurant" />
            <TextField source="name" label="Customer Name" />
            <TextField source="mobileNo" label="Mobile" />
            <TextField source="totalPayable" label="Amount" />
            <TextField source="paymentMode" label="Payment Mode" />
            <DeliveryAddress label="Address" />
            <DateField source="creationTime" showTime label="Order Time" />
            <DateField source="lastStatusUpdateTime" showTime label="Last Status Updated At" />
            <TextField source="lastStatusUpdatedUserName" label="Updated By" />
            <TextField source="adminComment" label="Comment" />
            <OrderStatus label="Status" />
        </Datagrid>
    </List>
);


